











import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "LiveStreamRulesConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    text: { type: String, required: true },
  },
});
